import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../AxiosInstance";
import useDistrict from "./useDistrict";
import { useDispatch } from "react-redux";
import {
  // getUserAuthorizedAddress,
  // setAuthorizedAddress,
  // getUserToken,
  setDistrict,
  setLocalUser,
  setPermissions,
} from "../stores/features/userSlice";
// import { useNavigate } from "react-router-dom";
import useAuthenticate from "./useAuthenticate";
import { queryClient } from "../App";
import { Constants } from "../constants";
// import { useEffect } from "react";
// import useLocation from "./useLocation";

const getAddresValidation = async (latitude, longitude) => {
  const response = await fetch(
    `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${Constants.googleMapsApiKey}`
  );
  const data = await response.json();

  if (data.results.length > 0) {
    return data.results[0].formatted_address;
  }

  return null;
};

function useGetUser() {
  const district = useDistrict();
  // console.log({ district });
  // const permissions = parseInt(localStorage.getItem("permissions"));
  // const access_token = useSelector(getUserToken);
  // const authorizedAddress = useSelector(getUserAuthorizedAddress);
  const isAuth = useAuthenticate();
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  // const dispatch = useDispatch();

  const userQuery = useQuery({
    queryKey: ["user", { query: isAuth, district: district || null }],
    staleTime: 100000,
    enabled: isAuth,
    queryFn: async () => {
      try {
        // axiosInstance.defaults.headers.common[
        //   "Authorization"
        // ] = `Bearer ${access_token}`;
        const { data } = await axiosInstance.get("current_user/");
        let userData = data;

        if (!data || !data.user_data) {
          throw new Error("Invalid user data");
        }

        // console.log({ district, userData: data?.user_data });

        if (data?.user_data?.role === 0) {
          console.log(
            "User is a simple user, we are here to update the location"
          );
        }

        // Vérification et mise à jour du district si nécessaire
        if (
          district?.id &&
          data?.user_data?.district?.id !== district?.id &&
          data?.user_data?.role === 0
        ) {
          console.log("we are here to update the district");
          try {
            let newAddress = district?.addressResponse;
            if (!district?.addressResponse) {
              newAddress = await getAddresValidation(
                district?.form?.lat,
                district?.form?.lng
              );
            }

            const { data: newData } = await axiosInstance.post(
              `set_location/`,
              {
                latitude: district?.form?.lat,
                longitude: district?.form?.lng,
                address: newAddress,
              }
            );

            // Mise à jour du district dans le store Redux
            dispatch(
              setDistrict({
                ...newData,
                addressResponse: newAddress,
                address: newAddress,
                form: {
                  lat: district?.form?.lat,
                  lng: district?.form?.lng,
                },
              })
            );

            // Invalider le cache pour forcer une nouvelle requête
            queryClient.invalidateQueries(["user"]);

            // Récupération des données utilisateur mises à jour
            const { data: newUserData } = await axiosInstance.get(
              "current_user/"
            );
            userData = newUserData;
          } catch (updateError) {
            console.error(
              "Erreur lors de la mise à jour du district:",
              updateError
            );
            // On continue avec les données utilisateur existantes en cas d'erreur
          }
        }

        // set the permissions
        dispatch(setPermissions(userData?.user_data?.role));
        dispatch(setLocalUser(userData?.user_data));
        return userData;
      } catch (error) {
        if (error.response?.status === 500) {
          console.warn("Erreur 500 - Serveur indisponible");
          localStorage.removeItem("access_token");
          return undefined;
        }
        throw error;
      }
    },
  });

  // useEffect(() => {
  //   if (userQuery?.data) {
  //     // console.log({ userQuery: userQuery?.data });
  //     if (userQuery?.data?.user_data?.district?.id) {
  //       console.log("we are here to update the district");

  //       axiosInstance
  //         .post(`set_location/`, {
  //           // latitude: district?.form?.lat,
  //           // longitude: district?.form?.lng,
  //           // address: district?.form?.address,
  // address: "MH57+JMJ, Rue Mermoz, Dakar, Sénégal",
  // latitude: 14.65913700000003,
  // longitude: -17.435989000000006,
  //         })
  //         .then((res) => {
  //           console.log({ res });
  //           queryClient.invalidateQueries({
  //             queryKey: ["user", { query: isAuth, district }],
  //           });
  //         });
  //     }
  //   }
  // }, [userQuery?.data]);

  const warehouseQuery = useQuery({
    queryKey: ["warehouse-points", { query: district?.warehouse_id }],
    queryFn: async () => {
      const { data } = await axiosInstance.get(
        `warehouses/${district?.warehouse_id}/points/`
      );

      // Vérification si la réponse est valide
      if (!data) {
        throw new Error("Invalid payment data");
      }

      return data?.data;
    },
    enabled: !!district?.warehouse_id,
  });

  if (userQuery?.isError) {
    return null;
  }

  return {
    isLoading: userQuery?.isLoading,
    data: userQuery?.data,
    warehouse: warehouseQuery?.data || null,
  };
}

export default useGetUser;
